import React, { useEffect, useState } from 'react';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import { generateId } from '../utility/functions';
import Table from '../table/Table';

const AppBirthdayWashes = ({ ...props }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        HamQuest.get(QuestRoute.dashboard.birthdayWashes)
            .then(res => setData([
                {
                    label: 'Sent',
                    today: res.sentToday,
                    month: res.sentMonth,
                    year: res.sentYear,
                }, {
                    label: 'Redeemed',
                    today: res.redeemedToday,
                    month: res.redeemedMonth,
                    year: res.redeemedYear,
                }, {
                    label: 'Expired',
                    today: res.expiredToday,
                    month: res.expiredMonth,
                    year: res.expiredYear,
                },
            ]))
            .catch(ex => console.error(ex))
    }, [])

    return (
        <Table
            config={{
                disableHeaderSearch: true,
                disableTableControls: true,
                disableMobileView: true,
                data: data,
                headers: [
                    {
                        label: 'Birthday Wash',
                        propKey: 'label',
                    }, {
                        label: 'Today',
                        propKey: 'today',
                    }, {
                        label: 'Month',
                        propKey: 'month',
                    }, {
                        label: 'Year',
                        propKey: 'year',
                    }
                ],
                renderFormat: (e) => (
                    <tr key={generateId()}>
                        <td>{e.label}</td>
                        <td>{e.today}</td>
                        <td>{e.month}</td>
                        <td>{e.year}</td>
                    </tr>
                )
            }}
        />
    );
}

export default AppBirthdayWashes;